import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
const deduplicateSlots = slots => {
  if (!slots) {
    return undefined;
  }
  const seen = new Set();
  return slots.filter(entry => {
    var _entry$slot, _entry$slot2;
    const key = `${(_entry$slot = entry.slot) == null ? void 0 : _entry$slot.startDate}_${(_entry$slot2 = entry.slot) == null ? void 0 : _entry$slot2.endDate}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
export const getAvailabilitySlots = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    var _await$queryAvailabil;
    let {
      serviceId,
      selectedDate,
      timeZone
    } = _ref2;
    const fromLocalDate = getLocalDateTimeStartOfDay(selectedDate);
    const toLocalDate = getLocalDateTimeEndOfDay(selectedDate);
    const availabilityEntries = (_await$queryAvailabil = await queryAvailability({
      httpClient: _httpClient,
      errorHandler,
      request: {
        query: {
          filter: {
            serviceId: [serviceId],
            startDate: fromLocalDate,
            endDate: toLocalDate,
            bookable: true
          }
        },
        timezone: timeZone,
        allowProxyToAvailability: true
      }
    })) == null ? void 0 : _await$queryAvailabil.availabilityEntries;
    return deduplicateSlots(availabilityEntries);
  };
};
//# sourceMappingURL=get-availability-slots.js.map